// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/backgroundcps.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg-image 
{ 
background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center fixed;
background-size: cover;
}

@media (min-width: 576px) {
    .centro 
    {
      display: grid;
      place-items: center;
        /*position: fixed;
        top: 50%;
        left: 50%;
 
        transform: translate(-50%, -50%);*/
    }
}

.logoSize
{
  width:15%
}

.background {
  background-color: rgba(255, 255, 255, 0.8);
}

.background-topo {
  background-color: rgba(47,79,79, 0.9);
}

.separator {
  display: flex;
  align-items: center;
  text-align: center;
}

.separator::before,
.separator::after {
  content: '';
  flex: 1 1;
  border-bottom: 1px solid lightgray;
}

.separator:not(:empty)::before {
  margin-right: .25em;
}

.separator:not(:empty)::after {
  margin-left: .25em;
}
.check {
  accent-color: #2F4F4F;
}

.btn-custom{
  background-color: #2F4F4F;
  border-color: #2F4F4F;
  color:white
}

.btn-custom:hover{
  background: #385e5f;
  border-color: #385e5f;
  color:white
}

.table-head-scroll {
  display: table;
  width: 100%;
  table-layout: fixed;
}


.table-body-scroll {
  display: block;
  max-height: 300px;
  overflow-y: scroll;
}

input[type="radio"]:checked {
  background-color:rgb(47, 79, 79);
}

input[type="radio"] {
  border-color:rgb(47, 79, 79) !important;
}

input[type="checkbox"]:checked {
  background-color:rgb(47, 79, 79);
}

input[type="checkbox"] {
  border-color:rgb(47, 79, 79) !important;
}

.divHover:hover{
  background-color: #F1F1F1;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;AAEA,iFAA2E;AAI3E,sBAAsB;AACtB;;AAEA;IACI;;MAEE,aAAa;MACb,mBAAmB;QACjB;;;;0CAIkC;IACtC;AACJ;;AAEA;;EAEE;AACF;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,SAAO;EACP,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB;AACF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;;AAGA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".bg-image \n{ \nbackground: url(\"./assets/backgroundcps.png\") no-repeat center center fixed; \n-webkit-background-size: cover;\n-moz-background-size: cover;\n-o-background-size: cover;\nbackground-size: cover;\n}\n\n@media (min-width: 576px) {\n    .centro \n    {\n      display: grid;\n      place-items: center;\n        /*position: fixed;\n        top: 50%;\n        left: 50%;\n \n        transform: translate(-50%, -50%);*/\n    }\n}\n\n.logoSize\n{\n  width:15%\n}\n\n.background {\n  background-color: rgba(255, 255, 255, 0.8);\n}\n\n.background-topo {\n  background-color: rgba(47,79,79, 0.9);\n}\n\n.separator {\n  display: flex;\n  align-items: center;\n  text-align: center;\n}\n\n.separator::before,\n.separator::after {\n  content: '';\n  flex: 1;\n  border-bottom: 1px solid lightgray;\n}\n\n.separator:not(:empty)::before {\n  margin-right: .25em;\n}\n\n.separator:not(:empty)::after {\n  margin-left: .25em;\n}\n.check {\n  accent-color: #2F4F4F;\n}\n\n.btn-custom{\n  background-color: #2F4F4F;\n  border-color: #2F4F4F;\n  color:white\n}\n\n.btn-custom:hover{\n  background: #385e5f;\n  border-color: #385e5f;\n  color:white\n}\n\n.table-head-scroll {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n}\n\n\n.table-body-scroll {\n  display: block;\n  max-height: 300px;\n  overflow-y: scroll;\n}\n\ninput[type=\"radio\"]:checked {\n  background-color:rgb(47, 79, 79);\n}\n\ninput[type=\"radio\"] {\n  border-color:rgb(47, 79, 79) !important;\n}\n\ninput[type=\"checkbox\"]:checked {\n  background-color:rgb(47, 79, 79);\n}\n\ninput[type=\"checkbox\"] {\n  border-color:rgb(47, 79, 79) !important;\n}\n\n.divHover:hover{\n  background-color: #F1F1F1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
